
import { Vue, Options, Prop } from 'vue-property-decorator';
import { inject } from 'vue';
import ToolbarItem from './ToolbarItem.vue';
import EventBusConstants from '../../constants/EventBusConstants';
import PlayerEmitter from '@/event/PlayerEmitter';
import TextHelp from '../../util/TextHelp';

@Options({
  components: { ToolbarItem },
})
export default class TextToSpeechItem extends Vue {
  @Prop() clickToSpeakEnabled = false;
  @Prop() isPlaying = false;
  @Prop({ default: true }) readonly adjustForFocusMode: boolean | undefined;

  private emitter: PlayerEmitter | undefined = inject('playerEmitter');

  mounted() {
    this.emitter?.on(EventBusConstants.NAVIGATION_EVENT, this.stop);
    this.emitter?.on(EventBusConstants.ITEM_PICKED, this.stop);
    this.emitter?.on(EventBusConstants.PAUSE_BUTTON_CLICKED, this.stop);

    TextHelp.getAPI().then((api) => {
      api.speechTools.setSpeechStartedCallback(() => {
        this.isPlaying = true;
      });
      api.speechTools.setSpeechStoppedCallback(() => {
        this.isPlaying = false;
      });
    });

    this.adjustments();
  }

  private adjustments(): void {
    const toolContainer: Element = this.$el.querySelector('.outer-container');
    if (toolContainer && this.adjustForFocusMode) {
      toolContainer.classList.add('focus-mode-adjustment');
    }
  }

  getItemContainer() {
    let item = document.querySelector('#item-wrapper qti-item-body');
    if (item) {
      return item;
    }

    item = document.querySelector('#item-wrapper #inner-container');
    //console.log(item);
    return item;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  mouseClickedEvent(ev) {
    //console.log(ev.target);
    if (this.clickToSpeakEnabled == false) {
      console.warn('mouseClickedEvent was not un registered.');
      return;
    }

    TextHelp.getAPI().then((api) => {
      if (api && api.speechTools) {
        api.speechTools.clickToSpeak();
        if (api.speechTools.getClickToSpeakState() == false) api.speechTools.clickToSpeak();
      }
    });
  }

  enableClickToSpeak() {
    console.log('CTS Enabled');

    let itemBody = this.getItemContainer();
    itemBody?.addEventListener('click', this.mouseClickedEvent);
    itemBody?.setAttribute('style', 'cursor: pointer');

    this.clickToSpeakEnabled = true;
  }

  disableClickToSpeak() {
    console.log('CTS Disabled');

    let itemBody = this.getItemContainer();
    itemBody?.removeEventListener('click', this.mouseClickedEvent);
    itemBody?.removeAttribute('style');

    this.clickToSpeakEnabled = false;

    TextHelp.getAPI().then((api) => {
      if (api.speechTools.getClickToSpeakState() == true) {
        api.speechTools.clickToSpeak();
      }
    });
  }

  toggleClickToSpeak() {
    console.log('TextHelp.clickToSpeak()', this.clickToSpeakEnabled);

    if (this.clickToSpeakEnabled == false) {
      this.enableClickToSpeak();
    } else {
      this.disableClickToSpeak();
    }
  }

  play() {
    console.log('TextHelp.play()');
    TextHelp.getAPI().then((api) => {
      if (api && api.speechTools) {
        api.speechTools.speakElement(this.getItemContainer());
      }
    });
  }

  pause() {
    console.log('TextHelp.pause()');
    TextHelp.getAPI().then((api) => {
      if (api && api.speechTools) {
        api.speechTools.pause();
      }
    });
  }

  stop() {
    console.log('TextHelp.stop()');
    TextHelp.getAPI().then((api) => {
      if (api && api.speechTools) {
        if (this.clickToSpeakEnabled) this.disableClickToSpeak();
        else api.speechTools.stop();
      }
    });
  }
}
